import styles from './AutoDescription.scss';
import WoWSEntity from '@wg/wows-entities/wrappers/react/WoWSEntity';
import ChanceLabel from '~/components/ChanceLabel/ChanceLabel';
import PortPreviewButton from '~/components/PortPreviewButton/PortPreviewButton';
import { openPortByItem } from '~/settings/port';
import { settings } from '~/utils/settings';
import { PortPreviewType } from '~/components/Port/settings';
import { isInGameBrowser } from '~/utils/utils';
import { isCamouflage } from '~/components/Camouflages/Camouflages';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { HIDE_ALL_POPUPS, appActions } from '~/Store/appSlice';

interface IAutoDescriptionDefaultItem {
    reward: ILootboxReward;
    className?: string;
    inventoryCount?: number;
    bundleId?: number;
    lootboxId: number;
    onRender?: DefaultFunction;
    goToPortHandler?: () => void;
}

const AutoDescriptionDefaultItem = ({ reward, inventoryCount, className, bundleId, goToPortHandler, lootboxId, onRender }: IAutoDescriptionDefaultItem) => {
    const dispatch = useDispatch();

    const openPort = () => {
        dispatch(appActions.changeVisibilityPopup({ name: HIDE_ALL_POPUPS }));
        openPortByItem({
            item: {
                shipId: settings.camouflagePreviewDefaultShip,
                type: reward.type,
                identifier: reward.id,
            },
            bundleId,
            portPreviewType: PortPreviewType.CONTAINER,
            additionalData: { lootboxId },
        });
        goToPortHandler?.();
    };

    const isAvailablePortPreview = bundleId && isInGameBrowser && isCamouflage(reward.type) && settings.camouflagePreviewDefaultShip;

    return (
        <div className={classNames(styles.defaultItem, className)}>
            {isAvailablePortPreview && <PortPreviewButton onClick={openPort} className={styles.iconPortPreviewButton} onlyIcon />}
            <WoWSEntity
                id={reward.id}
                type={reward.type}
                className={styles.wowsEntity}
                amount={reward.amount}
                customisation={{
                    inventoryCount,
                }}
                presentation={{
                    withTooltip: true,
                    withText: true,
                    iconPosition: 'left',
                    renderWithoutFade: true,
                }}
                onRender={onRender}
            />
            <ChanceLabel chance={reward.probabilityDisplayed} />
        </div>
    );
};

export default AutoDescriptionDefaultItem;
